export default {
  CAPTURE: 'CAPTURE',
  REFUND: 'REFUND',
  CREATE_SUBSCRIBER: 'CREATE_SUBSCRIBER',
  DELETE_SUBSCRIBER: 'DELETE_SUBSCRIBER',
  CAPTURE_SUBSCRIBER: 'CAPTURE_SUBSCRIBER',
  gql: {
    GET_BRAND: `
      query($number: String!) {
        payboxGetBrand(number: $number) {
          PAYS
          MARQUE
          PRODUIT
        }
      }
    `,
    CAPTURE: `
      mutation(
        $amount: Int!
        $reference: String!
        $creditCard: PayboxCreditCard!
        $id3D: String
      ) {
        payboxCapture(
          id3D: $id3D
          amount: $amount
          reference: $reference
          creditCard: $creditCard
        ) {
          NUMTRANS
          NUMAPPEL
        }
      }
    `,
    CAPTURE_SUBSCRIBER: `
      mutation(
        $amount: Int!
        $reference: String!
        $subscriber: PayboxSubscriber!
      ) {
        payboxCaptureSubscriber(
          amount: $amount
          reference: $reference
          subscriber: $subscriber
        ) {
          NUMTRANS
          NUMAPPEL
        }
      }
    `,
    SUBSCRIBE: `
      mutation(
        $amount: Int!
        $uuid: String!
        $reference: String!
        $creditCard: PayboxCreditCard!
        $id3D: String
      ) {
        payboxSubscribe(
          id3D: $id3D
          uuid: $uuid
          amount: $amount
          reference: $reference
          creditCard: $creditCard
        ) {
          REFABONNE
          PORTEUR
        }
      }
    `,
    SUBSCRIBE_AND_CAPTURE: `
      mutation(
        $amount: Int!
        $uuid: String!
        $reference: String!
        $creditCard: PayboxCreditCard!
        $id3D: String
      ) {
        payboxSubscribeAndCapture(
          id3D: $id3D
          uuid: $uuid
          amount: $amount
          reference: $reference
          creditCard: $creditCard
        ) {
          REFABONNE
          PORTEUR
          NUMTRANS
          NUMAPPEL
        }
      }
    `,
  },
};
